<div
    class="flex-modal"
    [ngClass]="{ professional: c.type === 'professional', organization: c.type === 'organization' }"
>
    <div class="modal-header" [ngClass]="{ 'modal-header--hide': c.hideHeader }">
        <h4 class="modal-title">{{ c.title }}</h4>
        <p *ngIf="c.subtitle" class="modal-subtitle">{{ c.subtitle }}</p>
    </div>
    <div *ngIf="c.body" class="modal-body">
        <p>{{ c.body }}</p>
    </div>
    <ng-container #container></ng-container>
    <div class="modal-footer" *ngIf="!c.hasCustomFooter && c.type === 'professional'">
        <button type="button" class="ch-button ch-button-default" (click)="onDefaultClick()">
            {{ c.defaultButtonText }}
        </button>
        <button type="button" class="ch-button" *ngIf="c.isPrimaryButtonVisible" (click)="onPrimaryClick()">
            {{ c.primaryButtonText }}
        </button>
    </div>
    <div class="modal-footer" *ngIf="!c.hasCustomFooter && c.type === 'organization'">
        <button type="button" class="btn btn-default" (click)="onDefaultClick()">{{ c.defaultButtonText }}</button>
        <button type="button" class="btn btn-primary" *ngIf="c.isPrimaryButtonVisible" (click)="onPrimaryClick()">
            {{ c.primaryButtonText }}
        </button>
    </div>
</div>
